import React, { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../../../components/common/Button';
import LinkComponent from '../../../components/common/Link';
import WorkShopTable from './workShopTable';
import workshopApi from '../workshop-api';

const WorkShopHistory = () => {
  const [workshops, setWorkshops] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [messageAlert, setMessageAlert] = useState();
  const history = useHistory();
  const location = useLocation();
  const Alert = (props) => (
    <MuiAlert elevation={6} variant="filled" {...props} />
  );

  const handleCloseSnackbar = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setMessageAlert();
  };

  const fetchWorkShopData = async () => {
    try {
      const { data } = await workshopApi.fetchWorkshops();
      setWorkshops(data);
    } catch (error) {
      setMessageAlert({
        type: 'error',
        message: 'Hubo un error al obtener los talleres',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkShopData();
  }, [isLoading]);

  useEffect(() => {
    if (location.state?.snackbar) {
      setMessageAlert(location.state.snackbar);
      history.replace({
        ...location,
        state: {},
      });
    }
  }, [history, location]);

  return (
    <div className="user-container">
      <LinkComponent
        title="Volver"
        url="/formacion"
        icon="arrow_back"
      ></LinkComponent>

      <div className="content-panel">
        <div className="client__action-container">
          <span className="subtitle">Listado de talleres.</span>
          <Button
            type="button"
            primary
            onClick={() => history.push('/talleres/crear')}
          >
            <span className="material-icons">add</span>
            Nuevo taller
          </Button>
        </div>
        <WorkShopTable
          isLoading={isLoading}
          workshops={workshops}
          setIsLoading={setIsLoading}
          setMessageAlert={setMessageAlert}
          setWorkshops={setWorkshops}
        />
      </div>
      <Snackbar
        open={Boolean(messageAlert)}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={messageAlert?.severity || messageAlert?.type || 'success'}
        >
          {messageAlert?.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default WorkShopHistory;
